import React, { useRef, useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import MagicParticles from "../index/MagicParticles";
//import SimpleBar from 'simplebar-react';
//import 'simplebar-react/dist/simplebar.min.css';
import Header from "../index/Header";
import Footer from "../index/Footer";

export default function BaileFantasia() {
  const scrollRef = useRef();
  const bailes = [
    {
      title: "Baile de Máscaras",
      description: "Inspirado en los carnavales venecianos y castillos encantados. Música clásica y ambientación de época.",
      image: "/img/mascaras.jpg",
    },
    {
      title: "Noche de las Estaciones",
      description: "Cada baile se dedica a una estación del año. Flores, luces cálidas, o hielo y cristal según el evento.",
      image: "/img/estaciones.jpg",
    },
    {
      title: "Baile de los Reinos",
      description: "Evento literario donde representas una casa o reino fantástico, con pruebas, alianzas y danza.",
      image: "/img/reinos.jpg",
    },
  ];

  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nombre: "", email }),
      });

      if (res.ok) {
        setSuccess(true);
        setError(null);
        setEmail("");
      } else {
        const data = await res.json();
        setError(data.message || "Error al suscribirse");
      }
    } catch (err) {
      setError("Error de conexión");
    }
  };

   useEffect(() => {
      let timer;
      if (success || error) {
        timer = setTimeout(() => {
          setSuccess(false);
          setError(null);
        }, 2400);
      }
  
      return () => clearTimeout(timer);
    }, [success, error]);

  return (
    // <SimpleBar ref={scrollRef} style={{ maxHeight: '100vh' }} autoHide={false}>

    <main className="font-cinzel bg-eryndra-burgundy text-eryndra-cream relative z-10">
      <div className="absolute inset-0 z-20 pointer-events-none">
        <MagicParticles />
      </div>
      <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-burgundy/20" />
      <section className="relative  bg-cover bg-center text-center h-[83vh] overflow-hidden">
        <video
          className="absolute top-0 left-0 w-full h-[83vh] object-cover "
          src="/img/video.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="absolute inset-0 bg-gradient-to-b from-eryndra-forest/70 to-transparent flex items-center justify-center text-center">
          <div >
            <h1 className="font-title text-5xl md:text-8xl  mb-4  tracking-widest text-shadow-lg">BAileS De FAnTASíA</h1>
            <p className="text-lg md:text-2xl px-3 text-shadow-DEFAULT">Sumérgete en una noche de magia, música y ensueño</p>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 bg-eryndra-ivory/10 bg-eryndra-burgundy text-eryndra-cream text-center">
        <h2 className="text-3xl md:text-5xl font-bellefair text-eryndra-gold uppercase mb-4">Un viaje a otros mundos</h2>
        <p className="max-w-3xl mx-auto text-xl font-bellefair">
          Los Bailes de Fantasía de Eryndra son experiencias inmersivas inspiradas en la literatura fantástica, cuentos de hadas y épocas de ensueño.
          Creamos eventos donde cada detalle —vestuario, música, escenografía— está diseñado para hacerte vivir un cuento en primera persona.
        </p>

      </section>
      <section className="relative bg-eryndra-burgundy text-eryndra-ivory py-24 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 z-0 pointer-events-none">
          <MagicParticles />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bellefair text-eryndra-gold uppercase mb-4">¿Qué incluye un Baile de Eryndra?</h2>
          <p className="font-bellefair text-xl md:text-xl mb-12">
            Cada evento está diseñado para que vivas una experiencia completa de fantasía. Estos son los elementos que hacen que nuestros bailes sean inolvidables:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 text-left">
            <div className="flex items-start gap-4">
              <span className="text-2xl">🕯️</span>
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold">Ambientación temática</h4>
                <p className="font-bellefair text-lg">Castillo, bosque, salón real… Escenarios diseñados para transportarte.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="text-2xl">🪞</span>
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold">Decoración y atrezzo inmersivo</h4>
                <p className="font-bellefair text-lg ">Detalles cuidados que transforman el espacio en otro mundo.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="text-2xl">🎻</span>
              <div>
                <h4 className="font-bold text-eryndra-gold">Música en vivo o DJ</h4>
                <p className="font-bellefair text-lg">Selección musical personalizada para acompañar cada momento.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="text-2xl">🎭</span>
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold">Photocall temático</h4>
                <p className="font-bellefair text-lg">Un rincón mágico para inmortalizar recuerdos con estilo.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="text-2xl">🧝‍♀️</span>
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold">Personal caracterizado</h4>
                <p className="font-bellefair text-lg">Anfitrionas, actores y personajes que dan vida a tu historia.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="text-2xl">🧵</span>
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold">Asesoría de vestuario</h4>
                <p className="font-bellefair text-lg">Te ayudamos a elegir tu atuendo de ensueño (alquiler disponible).</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="text-2xl">🍷</span>
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold">Catering opcional</h4>
                <p className="font-bellefair text-lg">Gastronomía ambientada para deleitar todos los sentidos.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="text-2xl">📸</span>
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold">Fotografía y vídeo</h4>
                <p className="font-bellefair text-lg">Cobertura profesional para que guardes la magia por siempre.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="  bg-[url('/public/img/pergamino-textura.png')] bg-center bg-cover text-eryndra-forest py-20 px-6 text-center ">

        <h3 className="text-3xl font-bold md:text-4xl font-cinzel text-eryndra-forest mb-6 ">¿Te gustaría asistir al próximo Baile?</h3>
        <p className="font-bellefair text-xl mb-6">Déjanos tus datos y te informaremos de las próximas fechas y localizaciones.</p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row justify-center gap-4 max-w-xl mx-auto">
          <input
            type="email"
            placeholder="Tu correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="px-4 py-2 rounded-lg border border-eryndra-forest focus:outline-none"
            required
          />
          <button type="submit" className="btn-eryndra-forest">Quiero asistir</button>
        </form>
        <AnimatePresence mode="wait">
          <div className="mt-4">
              {success && (
                <motion.p
                  key="success"
                  className="text-green-600"
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -5 }}
                  transition={{ duration: 0.4 }}
                >
                  ¡Gracias por suscribirte!
                </motion.p>
              )}
              {error && (
                <motion.p
                  key="error"
                  className="text-red-600"
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -5 }}
                  transition={{ duration: 0.4 }}
                >
                  {error}
                </motion.p>
              )}
              </div>
            </AnimatePresence>
      </section>

      <Footer />
    </main>
    //</SimpleBar>
  );
}